'use strict';

import React from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import ServiceForm from '@/Form/ServiceForm'

import Link from '@Pure/Link'

export default PageWrapper(function NewServicePage (props)
{
	return (
		<Layout page_title="Nouveau service" history={ props.history }>

			<div className="page-content">

				<div className="u-flex u-content-end u-margin-bottom-20">
					<Link href="/gestion-des-services"
						className="c-btn u-no-margin-top">
						Retour aux services
					</Link>
				</div>

				<ServiceForm />

			</div>

		</Layout>
	);
});